import { RichText } from 'prismic-reactjs';
import { ICarouselProducts } from './types';
import { default as CarouselProductsComponent } from '@components/CarouselProducts';
import Link from 'next/link';
import CustomPrismicLink from '@components/CustomPrismicLink';
import { AddToShoppingCartSource, ICarouselCard } from '@monofront/types';

interface ICarouselProductsProps {
  card: ICarouselCard | undefined;
  position: number;
  content: Pick<
    ICarouselProducts,
    'title' | 'textLink' | 'text' | 'handle' | 'items' | 'trackingId'
  >;
}

export const CarouselProducts: React.FC<ICarouselProductsProps> = ({
  position,
  content,
  card,
}) => {
  const { title, handle, trackingId, text, items, textLink } = content;

  return (
    <section className="slice-carousel-products root">
      <div className="content">
        <CarouselProductsComponent
          headerTitle={
            <div className="header">
              <div className="title">
                <RichText render={title} />
                <div className="link-container">
                  <Link
                    href={`/collections/${handle}${
                      trackingId ? `?trackingId=${trackingId}` : ''
                    }`}
                    legacyBehavior
                  >
                    <a className="tw-lf-link-md tw-whitespace-nowrap">
                      <span>{textLink}</span>
                    </a>
                  </Link>
                </div>
              </div>
              <RichText render={text} serializeHyperlink={CustomPrismicLink} />
            </div>
          }
          products={items}
          trackingId={trackingId}
          containerContext={{
            source: AddToShoppingCartSource.CAROUSEL,
            widgetName: trackingId,
            widgetPosition: position ? `${position}` : undefined,
          }}
          card={card}
        />
      </div>
      <style jsx>{`
        .header {
          display: flex;
          flex-direction: column;
          margin-bottom: var(--space-4);
        }

        .title {
          display: flex;
          justify-content: space-between;
          width: 100%;
        }

        .link-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: var(--space-2);
        }

        @media (max-width: 800px) {
          .slice-carousel-products :global(.swiper) {
            margin: var(--negative-padding-layout-base);
            padding: var(--padding-layout-base);
            width: 100vw;
          }
        }
      `}</style>
    </section>
  );
};
